export function calculatePackagePricing({ price, details, hasWholePackage }) {
   const totalItemsPrice = details.reduce((sum, detail) => {
      const itemPrice = detail.itemPrice
      return sum + (Number(itemPrice) || 0)
   }, 0)

   const cleanedPrice = price?.toString().replace(/,/g, "") || "0"
   let mainPrice = 0
   let discount = null

   if (hasWholePackage) {
      mainPrice = Number(cleanedPrice) || 0
      discount = totalItemsPrice - mainPrice
   }

   return {
      totalItemsPrice,
      mainPrice,
      discount,
   }
}
